/* CSV for the browser exports (10-27, "Auto CPAP 4–20"): every cell quoted with embedded quotes doubled
   (RFC 4180), "\n" line ends as before, no byte-order mark. Text goes through as is: the Blob is UTF-8,
   so an en dash stays an en dash. */
export const csvCell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

export const toCsv = (rows) => rows.map((r) => r.map(csvCell).join(",")).join("\n");

export const csvBlob = (rows) => new Blob([toCsv(rows)], { type: "text/csv" });
